import React, { Component } from "react";
import Layout from "../../../Layout/layout";
import Helmet from "react-helmet";
import AnimateTable from "../../commoncomponents/animateTable";
import "../../../styles/reports/reports.scss";
import TempSummary from "./tempSummary";
import ExceptionTable from "./exceptionTable";
import LogTable from "./logTable";
import TemperatureChart from "./temperatureChart";
import axios from "axios";
import { apiHost } from "../../../api/apiClient";
import { utcToDate } from "../../../utils/dateConvert";
import { connect } from "react-redux";
import {
  setLoadingPage,
  setErrorMessage,
  setReportAssetId,
  setReportCalendatDate,
  setReportAssetName,
} from "../../../reducers/actions";
import queryString from "query-string";
import moment from "moment";
import AssetInforWarning from "../../commoncomponents/assetInforWarning";

class Temperature extends Component {
  constructor(props) {
    super(props);
    this.state = {
      assetId: "",
      filter: false,
      date: new Date(),
      tempDataExceptionList: [],
      tempDataLogList: [],
      timeX: [],
      tempY: [],
      xPoint: [],
      assetName: "",
      assetSelect: false,
      dateSelect: true,
      reportStart: "",
      reportEnd: "",
      reportDuration: "",
      thresholdA: "",
      thresholdB: "",
      generated: "",
      showContent: false,
      generatedDate: moment().format("DD-MMM hh:mm a"),
      selectedDate: moment().format("YYYY-MM-DD"),
      dateplaceholder: moment().format("dddd Do MMMM, YYYY"),
      contentChart: false,
      totalGraph: [],
      totalGraphSecond: [],
      timeUtc: [],
      utcObj: {},
    };
  }
  async componentDidMount() {
    const values = queryString.parse(this.props.location.search);

    console.log("assetDate from temperature ", values);

    if (values.assetId) {
      console.log("AssetId from temperature ", values.assetId);
      console.log("Assetname from temperature ", values.assetName);
      await this.setState({
        assetName: values.assetName,
        assetCustomerName:values.assetName,
        assetId: values.assetId,
      });

      if (values.assetDate !== undefined && values.assetDate !== "null") {
        await this.setState({
          selectedDate: values.assetDate,
          ReportDate: values.assetDate,
          dateplaceholder: moment(values.assetDate).format(
            "dddd Do MMMM, YYYY"
          ),
        });
      }
      this.handleCreateReport();
    }
  }

  getTemperatureData = async (url) => {
    this.props.setLoadingPageAction(true);

    let assetID = this.state.assetId;
    let assetName = this.state.assetName;

    this.props.setReportAssetIdAction(assetID);
    this.props.setReportAssetNameAction(assetName);
    this.props.setReportCalendatDateAction(this.state.selectedDate);

    console.log("date checkkkk", this.state.selectedDate);

    try {
      let tempData = await axios.post(
        url,
        {
          AssetId: this.state.assetId,
          SearchDate: this.state.selectedDate,
          Timezone: localStorage.getItem("timeZoneID"),
          UseFiltering: false,
        },
        {
          headers: {
            Authorization: "Bearer " + localStorage.getItem("token"),
          },
        }
      );

      console.log("tempData", tempData.data.temperatureExceptionsDtos);

      this.props.setLoadingPageAction(false);
      this.setState({ contentChart: false });
      this.setState({
        tempDataExceptionList: tempData.data.temperatureExceptionsDtos,
        tempDataLogList: tempData.data.temperatureLogsDtos,
        reportStart: tempData.data.reportStart,
        reportEnd: tempData.data.reportEnd,
        reportDuration: tempData.data.reportDuration,
        thresholdA: tempData.data.tempAthreshold,
        thresholdB: tempData.data.tempBthreshold,
        showContent: true,
        generatedDate: moment().format("DD-MMM, hh:mm a"),
        isTempBEnabled: tempData.data.assetTempB,
        isTempAEnabled:tempData.data.assetTempA
      });
      this.setGraph(tempData.data.temperatureLogsDtos);
    } catch (e) {
      if (e && e.response.status == "401") {
        this.props.history.push("/login");
      } else {
        this.props.setErrorMessageAction(`${e}`);
      }
      this.props.setLoadingPageAction(false);

      console.log(`😱 Axios request failed: ${e}`);
    }
  };

  setGraph = (data) => {
    var timeX = [];
    var timeUtc = [];
    var utcObj = {};
    var tempY = [];
    var totalGraph = [];
    var totalGraphSecond = [];
    var timeZoneID = localStorage.getItem("timeZoneID");

    data.forEach((single) => {
      let newtime = moment.utc(single.date).tz(timeZoneID).format();
      var timezoneOffset = moment(newtime);
      console.log("time zone offset", timezoneOffset._tzm);
      var timeZoneSeconds = timezoneOffset._tzm;
      var myDate = new Date(single.date);
      var result = myDate.getTime();
      var seconds = timeZoneSeconds * 60 * 1000;

      let value = result + seconds;
      let valueUtc = utcToDate(single.date);
      utcObj[value] = valueUtc;
      let point = parseFloat(single.tempA);
      let pointSecond = parseFloat(single.tempB);
      tempY.push(point);
      let totalPoint = [value, point];
      let totalPointSecond = [value, pointSecond];

      if (!timeX.includes(value)) {
        timeX.push(value);
        timeUtc.push(valueUtc);
        totalGraph.push(totalPoint);
        totalGraphSecond.push(totalPointSecond);
      }
    });

    let xPoint = ["00:30", "01:30"];
    this.setState({
      timeX,
      tempY,
      utcObj,
      timeUtc,
      totalGraph,
      totalGraphSecond,
      xPoint,
    });
  };

  dateSplitter = (date) => {
    let Arr = [];
    Arr[0] = moment(date).format("DD");
    Arr[1] = moment(date).format("MM");
    Arr[2] = moment(date).format("YYYY");
    return Arr;
  };

  Comparator = (a, b) => {
    if (a[0] < b[0]) return -1;
    if (a[0] > b[0]) return 1;
    return 0;
  };

  searchForArray = (haystack, needle) => {
    var i, j, current;
    for (i = 0; i < haystack.length; ++i) {
      if (needle.length === haystack[i].length) {
        current = haystack[i];
        for (j = 0; j < needle.length && needle[j] === current[j]; ++j);
        if (j === needle.length) return i;
      }
    }
    return -1;
  };

  getHour = (hour) => {
    var a = hour;
    var b = a.split(":");
    let second = parseFloat(b[2]) / 60;
    let minute = parseFloat(b[1]);
    let totalminutes = minute + second;
    let hours = parseFloat(b[0]);
    let totalHour = hours + totalminutes / 60;

    return totalHour;
  };

  handleAssetId = (assetId) => {
    this.setState({ assetId, assetSelect: true });
  };

  handleDate = (date) => {
    this.setState({
      date,
      dateSelect: true,
      selectedDate: moment(date).format("YYYY-MM-DD"),
      dateplaceholder: moment(date).format("dddd Do MMMM, YYYY"),
    });
  };

  handleFilter = (filter) => {
    this.setState({ filter: filter });
  };
  handleAssetName = (assetname) => {
    this.setState({ assetName: assetname });
  };

  handleCreateReport = () => {
    let url = `${apiHost}/api/Report/TemperatureReport`;
    console.log("url", url);
    this.getTemperatureData(url);
    // this.getTemperatureData(
    //   "http://116.118.248.93/api/Report/TemperatureReport/08d7c00a-f58f-4d4a-8f29-1b35a4dd9518/2020-03-11T05:30:00Z/melborn"
    // );
  };

  render() {
    const groupTable = [
      { customer: "john", name: "jean", description: "testing" },
      { customer: "john2", name: "jean2", description: "testing" },
      { customer: "john3", name: "jean3", description: "testing" },
      { customer: "john4", name: "jean4", description: "testing" },
    ];

    return (
      <Layout>
        <Helmet>
          <title>Temperature</title>
        </Helmet>
        <div className="contentBody">
          <div
            className={
              !this.props.headerHide
                ? `contentWrapper contentWrapperSmoothRelease`
                : `contentWrapper contentWrapperSmooth`
            }
          >
            <AnimateTable
              assetPlaceHolder={this.state.assetName}
              groupTable={groupTable}
              heading="Temperature Report"
              onAssetId={this.handleAssetId}
              onDate={this.handleDate}
              onFilter={this.handleFilter}
              onCreateReport={this.handleCreateReport}
              filtering={false}
              assetSelect={this.state.assetSelect}
              dateSelect={this.state.dateSelect}
              dateplaceholder={this.state.dateplaceholder}
              onAssetName={this.handleAssetName}
              fromTemp={true}
            />
            {this.state.showContent && this.state.reportStart ?
              <React.Fragment>
                <TempSummary
                  start={utcToDate(this.state.reportStart)}
                  end={utcToDate(this.state.reportEnd)}
                  duration={this.state.reportDuration}
                  logNumber={this.state.tempDataLogList.length}
                  exceptionNumber={this.state.tempDataExceptionList.length}
                  generated={this.state.generatedDate}
                />
                <TemperatureChart
                  totalGraph={this.state.totalGraph.filter(point => !isNaN(point[1]))}
                  totalGraphSecond={this.state.totalGraphSecond.filter(point => !isNaN(point[1]))}
                  timeUtc={this.state.timeUtc}
                  tempBEnabled={this.state.isTempBEnabled}
                  utcObj={this.state.utcObj}
                  xCategory={this.state.xPoint}
                  selectedDate={this.state.selectedDate}
                />

                <ExceptionTable
                  exceptionTable={this.state.tempDataExceptionList}
                  thresholdA={this.state.thresholdA}
                  thresholdB={this.state.thresholdB}
                  assetCustomerName={this.state.assetName}
                  calendarSelectedDate={this.state.date}
                />

                <LogTable logTable={this.state.tempDataLogList}
                  assetId={this.state.assetId}
                  tempAEnabled={this.state.isTempAEnabled}
                  tempBEnabled={this.state.isTempBEnabled}
                  assetCustomerName={this.state.assetName}
                  calendarSelectedDate={this.state.date} />
              </React.Fragment>
              :
              <AssetInforWarning
                warningText={true}
                warningTextMsg="No Data Available"
              />
            }
          </div>
        </div>
      </Layout>
    );
  }
}

const mapStateToProps = (state) => ({
  loading: state.loading,
  headerHide: state.headerHide,
});
const mapDispatchToProps = {
  setLoadingPageAction: setLoadingPage,
  setErrorMessageAction: setErrorMessage,
  setReportAssetIdAction: setReportAssetId,
  setReportCalendatDateAction: setReportCalendatDate,
  setReportAssetNameAction: setReportAssetName,
};

export default connect(mapStateToProps, mapDispatchToProps)(Temperature);
